import React, { createContext, useState, useEffect } from 'react';
import { registerLogoutCallback } from '../utils/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
    localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null
  );

  const login = (userData) => {
    const enrichedData = { ...userData, token: 'session_cookie' };
    setUser(enrichedData);
    localStorage.setItem('userInfo', JSON.stringify(enrichedData));
  };

  const logout = async () => {
    setUser(null);
    localStorage.removeItem('userInfo');
    try {
      await fetch('/api/auth/logout', { method: 'POST' });
    } catch (err) {
      console.error('Error logging out from backend:', err);
    }
  };

  useEffect(() => {
    registerLogoutCallback(() => {
      setUser(null);
      localStorage.removeItem('userInfo');
    });
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
